<div class="pointer-events-auto w-full h-full overflow-hidden rounded-lg bg-white ">
  <div class="p-4 h-full flex flex-col justify-between">
    <div class="flex items-start">
      <div class="shrink-0">
        <ng-container [ngSwitch]="data.type">
          <svg *ngSwitchCase="'success'" class="w-12 h-12 text-green-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
          <svg *ngSwitchCase="'error'" class="size-6 text-red-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
          <svg *ngSwitchCase="'warning'" class="size-6 text-yellow-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.054 0 1.636-1.14 1.077-2.016L13.077 4.984c-.558-.876-1.596-.876-2.154 0L4.077 16.984c-.558.876.023 2.016 1.077 2.016z" />
          </svg>
        </ng-container>
      </div>
      <div class="ml-3 w-0 flex-1 pt-0.5">
        <p class="text-sm font-medium text-gray-900">{{ data.message }}</p>
        <!-- <p class="mt-1 text-sm text-gray-500">Anyone with a link can now view this file.</p> -->
      </div>
      <div class="ml-4 flex shrink-0">
        <button type="button" class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" (click)="close()">
          <span class="sr-only">Close</span>
          <svg class="size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>


